import React, { Component } from "react"
import Relay from "react-relay"
import { find } from "lodash/collection"
import classNames from "classnames"
import Modal from "react-modal"
import ShareModal from "./ShareModal"
import Licence from "../elements/Licence"
import { licenseTypes } from "../../scripts/licenseTypes"
import sharedMessages from "../../messages/index"
import articleMessages from "../../messages/article"
import settingsMessages from "../../messages/settings"
import { FormattedMessage, injectIntl } from "react-intl"
import { getPermalink } from "../../scripts/resource"
import Icon from "../elements/Icon"
import Tags from "./Tags"
import ResourceLocation from "./ResourceLocation"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import {CON_TOP_MUSEUM_HOSTNAME, isClient} from "../../constants";

class ArticleMetaShare extends Component {
  handleOpenModal = activeTab => {
    const { relay } = this.props
    relay.setVariables({ showingModal: true, activeTab })
  }

  handleCloseModal = () => {
    const { relay, closeModal } = this.props
    relay.setVariables({ showingModal: false })

    if (closeModal) {
      closeModal()
    }
  }

  render() {
    const {
      resource,
      active,
      loggedIn,
      relay: {
        variables: { showingModal, activeTab }
      },
      intl
    } = this.props
    const {
      license: licenseProp,
      coverage,
      date_humanized,
      rightsholder
    } =
      JSON.parse(resource.custom_fields)

    const titleEscaped = encodeURIComponent(resource.title)

    const license = find(licenseTypes, { name: licenseProp ? licenseProp.value : "" })
    const permalink = getPermalink(resource)

    const {
      settings: {
        style: { content: styleType },
        contact_email: contactEmail
      },
      authentic_account_id: authenticAccountId
    } = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )

    const isCopyright = license && license.copyright

    const showDownloads =
      !(isCopyright && resource.type === "audio") &&
      !(isCopyright && resource.type === "video") &&
      (!(resource.files && resource.files.length < 1) ||
        !(active.files && active.files.length < 1)) &&
      !(resource.type === "article") &&
      !(authenticAccountId === 17242) // Cone Top Brewery Museum

    return (
      <div>
        {getStyleTag([
          "c-article__actions",
          "c-article__defs",
          "c-article__buttons"
        ])}
        {styleType !== "default" && (
          <section className="c-article__details actions">
            <button
              onClick={() => this.handleOpenModal("share")}
              className={classNames(
                "share-button button button--text-and-icon"
              )}
              style={getStyles("c-article__share-button")}
            >
              <FormattedMessage {...articleMessages.share} />
              <Icon icon={"share"} />
            </button>
            {showDownloads && (
              <button
                onClick={() => this.handleOpenModal("download")}
                className={classNames(
                  "download-button button button--text-and-icon"
                )}
                style={getStyles("c-article__download-button")}
              >
                <FormattedMessage {...articleMessages.download} />
                <Icon icon={"download"} />
              </button>
            )}
            <Modal
              isOpen={showingModal}
              ariaHideApp={false}
              onRequestClose={this.handleCloseModal}
            >
              {getStyleTag("modal")}
              <ShareModal
                resource={active}
                activeTab={activeTab}
                onClose={this.handleCloseModal}
                showDownloads={showDownloads}
                isCopyright={isCopyright}
              />
            </Modal>
          </section>
        )}
        {/* TODO: Refactor after presentation */}
        {isClient && (window.location.hostname !== CON_TOP_MUSEUM_HOSTNAME) && (
          <section className="c-article__details">
            <h3>
              <FormattedMessage {...articleMessages.creation} />
            </h3>
            <dl className="c-article__defs">
              <div className="list__def">
                <dt>
                  <FormattedMessage {...articleMessages.createdBy} />
                </dt>
                {resource.creator && (
                  <dd itemProp="author">{resource.creator}</dd>
                )}
                {!resource.creator && <dd itemProp="author">Unknown</dd>}
              </div>
              {coverage && (
                <div className="list__def">
                  <dt>
                    <FormattedMessage {...articleMessages.place} />
                  </dt>
                  <dd itemProp="contentLocation">{coverage.value}</dd>
                </div>
              )}
              {date_humanized && (
                <div className="list__def">
                  <dt>
                    <FormattedMessage {...sharedMessages.formDate} />
                  </dt>
                  <dd itemProp="dateCreated">{date_humanized.value}</dd>
                </div>
              )}
            </dl>
          </section>
        )}
        {styleType === "default" && (
          <section className="c-article__details">
            <button
              onClick={() => this.handleOpenModal("share")}
              className={classNames(
                "share-button button button--text-and-icon"
              )}
            >
              <Icon icon={"share"} />
              <FormattedMessage {...articleMessages.share} />
            </button>
            {showDownloads && (
              <button
                onClick={() => this.handleOpenModal("download")}
                className={classNames(
                  "download-button button button--text-and-icon"
                )}
                style={getStyles("c-article__download-button")}
              >
                <Icon icon={"download"} />
                <FormattedMessage {...articleMessages.download} />
              </button>
            )}
            <Modal
              isOpen={showingModal}
              ariaHideApp={false}
              onRequestClose={this.handleCloseModal}
            >
              {getStyleTag("modal")}
              <ShareModal
                resource={active}
                activeTab={activeTab}
                onClose={this.handleCloseModal}
                showDownloads={showDownloads}
                isCopyright={isCopyright}
              />
            </Modal>
          </section>
        )}
        {!!resource.location_data && (
          <section className="c-article__details">
            <ResourceLocation resource={resource} />
          </section>
        )}
        {/* TODO: Refactor after presentation */}
        {isClient && (window.location.hostname !== CON_TOP_MUSEUM_HOSTNAME) && (
          <section className="c-article__details">
            <h3>
              <FormattedMessage {...articleMessages.objectRights} />
            </h3>
            <dl className="c-article__defs">
              {license && (
                <div className="list__def list__def--inline links--dark ">
                  <dt>
                    <FormattedMessage {...sharedMessages.formLicense} />
                  </dt>
                  <dd>
                    <Licence resource={resource}/>
                  </dd>
                </div>
              )}
            </dl>
          </section>
        )}

        <Tags resource={resource} userAddable={loggedIn}/>

        <div
          className="c-article__actions"
          style={getStyles("c-article__actions")}
        >
          <p>
            <a
              href={
                `mailto:${contactEmail}?subject=Report a Problem - ` +
                titleEscaped +
                "&body=%0D%0A%0D%0APage - " +
                permalink +
                "%0D%0AItem ID - " +
                resource.id
              }
            >
              {styleType !== "default" ? <Icon icon="problem" /> : null}
              <FormattedMessage {...articleMessages.reportAProblem} />
            </a>
          </p>
        </div>
      </div>
    )
  }
}

export default Relay.createContainer(injectIntl(ArticleMetaShare), {
  initialVariables: {
    showingModal: false,
    activeTab: "share"
  },

  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        id
        type
        title
        custom_fields
        creator
        location_data
        files {
          type
        }
        ${Tags.getFragment("resource")}
        ${Licence.getFragment("resource")}
        ${ResourceLocation.getFragment("resource")}
    }
    `,
    active: ({ activeTab }) => Relay.QL`
      fragment on Resource {
          type
          files {
              type
          }
          ${ShareModal.getFragment("resource", { activeTab })}
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/ArticleMetaShare.js